import React, { Component } from 'react';
import {
  Modal, Label, Popup, List, Table, Header, Image
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import $ from 'jquery';
import cx from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { v4 as uuidv4 } from 'uuid';
import Loader from '../Loader/Loader';
import api from '../../api';
import userPic from '../../images/components/profile/profile_icon_1.png';
import closeBtn from '../../images/common/close-btn.svg';
import searchIcon from '../../images/common/search_icon.png';
import WithRouter from '../Extensions/WithRouter';

class AssigningIssueModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMAI: props.isOpenMAI,
      checkedValue: props.checkedValue,
      unCheckedValue: props.unCheckedValue,
      checkAllArray: props.checkAllArray,
      rowData: props.rowData,
      isOpen: false,
      searchKeyword: '',
      errSearch: false,
      isFocus: false,
      //itemsChecked: false,
      groupPopup: false,
      rowDataPopup: false,
      group: [],
      selectedId: '',
      memberList: [],
      activeIndex: '',
      pageSize: 100,
      isLoading: props.isLoading,
    };
    this.closeModal = this.closeModal.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleSelectMember = this.handleSelectMember.bind(this);
    this.handleProjectMemberChange = this.handleProjectMemberChange.bind(this);
    this.handleSearchMember = this.handleSearchMember.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.renderCloseGroup = this.renderCloseGroup.bind(this);
    this.rowDataPopupOpen = this.rowDataPopupOpen.bind(this);
    this.rowDataPopupClose = this.rowDataPopupClose.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.setting_popup .table_type_3 .text', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps) {
    const {
      isLoading, isOpenMAI, rowData, checkedValue, unCheckedValue, checkAllArray
    } = this.props;

    if (prevProps.isLoading !== isLoading) {
      this.setState({
        isLoading,
      });
    }

    if (prevProps.isOpenMAI !== isOpenMAI) {
      this.setState({
        isOpenMAI,
        searchKeyword: '',
        checkedValue,
        checkAllArray,
        memberList: [],
        unCheckedValue,
        groupPopup: false,
        rowDataPopup: false,
        group: [],
        rowData,
        selectedId: '',
      }, () => {
        if (isOpenMAI) {
          this.searchIssueOwner();
        }
      });
    }
  }

  handleProjectMemberChange(e) {
    this.setState({
      searchKeyword: e.target.value,
      //searchKeywordError: '',
    });
  }

  handleSearchMember(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
            isFocus: false,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
                isFocus: true,
              });
            }, 1500);
          }
        );
        return false;
      }
      this.setState(
        {
          memberList: [],
        },
        () => {
          this.searchIssueOwner();
          setTimeout(() => {
            this.setState({
              isFocus: false,
            });
          }, 1500);
        }
      );
    }
  }

  handleSelectMember(memberId) {
    const { selectedId } = this.state;
    if (memberId === selectedId) {
      this.setState({
        selectedId: '',
      });
    } else {
      this.setState({
        selectedId: memberId,
      });
    }
  }

  handleFocus() {
    this.setState({
      isFocus: true,
    });
  }

  handleBlur() {
    this.setState({
      isFocus: false,
    });
  }

  onSubmit() {
    const {
      selectedId, checkedValue, unCheckedValue, checkAllArray, rowData
    } = this.state;
    const { location, completeCallback } = this.props;
    const path = location.pathname ? location.pathname : location;

    if (selectedId === '') {
      this.setState({
        isOpen: true,
      });
      return false;
    }

    let checked = [];
    let unChecked = [];

    if (checkAllArray.length !== 0) {
      checked = checked.concat(checkAllArray);
      const filterCheckAll = checkedValue.filter((item) => {
        if (typeof item === 'string') {
          const string = item.split('_');
          return checkAllArray.indexOf(Number(string[0])) === -1;
        }
        return item;
      });
      checked = this.uniqueFilter(checked.concat(filterCheckAll));
      checked = checked.map((item) => {
        if (typeof item === 'number') {
          return item.toString();
        }
        return item;
      });
      unChecked = unChecked.concat(unCheckedValue);
    } else {
      checked = this.uniqueFilter(checked.concat(checkedValue));
      checked = checked.map((item) => {
        if (typeof item === 'number') {
          return item.toString();
        }
        return item;
      });
    }

    if (path.indexOf('my_page') > -1) {
      api
        .setAssignMyIssue({
          user_id: selectedId,
          checked,
          unchecked: unChecked,
        })
        .then((response) => {
          const uploadedFileIds = [];
          rowData.map((item) => {
            if (Array.isArray(item)) {
              return item.map((nest) => {
                return uploadedFileIds.push(nest.uploaded_file_id);
              });
            }
            return uploadedFileIds.push(item.uploaded_file_id);
          });

          const unique = uploadedFileIds.reduce((a, b) => {
            if (a.indexOf(b) < 0) {
              a.push(b);
            }
            return a;
          }, []);
          if (response.response) {
          //this.closeModal();
            completeCallback(unique);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      api
        .setAssignIssue({
          user_id: selectedId,
          checked,
          unchecked: unChecked,
        })
        .then((response) => {
          const uploadedFileIds = [];
          rowData.map((item) => {
            if (Array.isArray(item)) {
              return item.map((nest) => {
                return uploadedFileIds.push(nest.uploaded_file_id);
              });
            }
            return uploadedFileIds.push(item.uploaded_file_id);
          });

          const unique = uploadedFileIds.reduce((a, b) => {
            if (a.indexOf(b) < 0) {
              a.push(b);
            }
            return a;
          }, []);

          if (response.response) {
          //this.closeModal();
            completeCallback(unique);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  getProfileImg(value) {
    const profileImg = `/1/users/me/profile_image/${value}`;

    let baseUrl = '//'.concat(location.hostname);
    let profileImgUrl = '';

    if (process.env.NODE_ENV === 'development') {
      baseUrl = baseUrl.concat(':3000');
    } else {
      baseUrl = location.port !== '' ? baseUrl.concat(':', location.port) : '';
    }

    profileImgUrl = profileImg !== '' ? baseUrl.concat(profileImg) : userPic;

    return profileImgUrl;
  }

  /*
  handleCheckChange(e, { value }) {
    const { checkValue, memberList } = this.state;
    let newState;

    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
      this.setState({
        checkValue: newState,
        itemsChecked: false,
      });
    } else {
      newState = [...checkValue, value];

      if (newState.length === memberList.length) {
        this.setState({
          itemsChecked: true,
          checkValue: newState,
        });
      } else {
        this.setState({
          checkValue: newState,
        });
      }
    }
  }
  handleUserCheckAll() {
    const { itemsChecked, memberList } = this.state;
    const newState = [];

    if (itemsChecked) {
      this.setState({
        itemsChecked: false,
        checkValue: [],
      });
    } else {
      let i = 0;
      for (i; i < memberList.length; i++) {
        newState.push(memberList[i].id);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        itemsChecked: true,
        checkValue: unique,
      });
    }
  }
  */

  guideText = () => {
    const { translate } = this.props;
    return translate('modal.title.placeholder_name_email');
  };

  closeErrorModal() {
    this.setState({
      isOpen: false,
    });
  }

  closeModal() {
    const { closeModal } = this.props;
    this.setState({
      isOpenMAI: false,
    });
    closeModal();
  }

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        memberList: [],
      },
      () => {
        this.searchIssueOwner();
      }
    );
  }

  convertToString(string) {
    if (string === 'clarityadmin@insignary.com') {
      return 'Admin';
    } if (string === 'licensemanager@insignary.com') {
      return 'Licensemanager';
    }
    return string;
  }

  searchIssueOwner(pageNo, perPage) {
    const { searchKeyword, pageSize, memberList } = this.state;
    const page = pageNo || 1;
    const limit = perPage || pageSize;
    const { checkedValue, unCheckedValue, checkAllArray } = this.props;
    let checked = [];
    let unChecked = [];

    if (checkAllArray.length !== 0) {
      checked = checked.concat(checkAllArray);
      const filterCheckAll = checkedValue.filter((item) => {
        if (typeof item === 'string') {
          const string = item.split('_');
          return checkAllArray.indexOf(Number(string[0])) === -1;
        }
        return item;
      });
      checked = this.uniqueFilter(checked.concat(filterCheckAll));
      checked = checked.map((item) => {
        if (typeof item === 'number') {
          return item.toString();
        }
        return item;
      });
      unChecked = unChecked.concat(unCheckedValue);
    } else {
      checked = this.uniqueFilter(checked.concat(checkedValue));
      checked = checked.map((item) => {
        if (typeof item === 'number') {
          return item.toString();
        }
        return item;
      });
    }

    api
      .searchIssueOwner({
        search: searchKeyword || '',
        checked,
        unchecked: unChecked,
        page,
        limit,
      })
      .then((response) => {
        const res = response.response;

        this.setState({
          memberList: [...memberList, ...res],
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  uniqueFilter(array) {
    const unique = array.reduce((a, b) => {
      if (a.indexOf(b) < 0) {
        a.push(b);
      }
      return a;
    }, []);
    return unique;
  }
  /*
  divideStr(groups) {
    const groupName = groups[0];
    const groupCount = groups.length - 1;
    if (groupName.length + groupCount.toString().length > 20) {
      return `${groupName.substr(0, 16)}...(${groupCount})`;
    }
    return `${groupName}(${groupCount})`;
  }
*/

  rowDataPopupOpen() {
    this.setState({
      rowDataPopup: true,
      groupPopup: false,
      activeIndex: '',
    });
  }

  rowDataPopupClose() {
    this.setState({
      rowDataPopup: false,
      groupPopup: false,
      activeIndex: '',
    });
  }

  renderGroup(id, arr) {
    this.setState({
      groupPopup: true,
      activeIndex: id,
      group: arr,
      rowDataPopup: false,
    });
  }

  renderCloseGroup() {
    this.setState({
      groupPopup: false,
      activeIndex: '',
      rowDataPopup: false,
    });
  }

  render() {
    const {
      searchKeyword,
      errSearch,
      isFocus,
      memberList,
      selectedId,
      activeIndex,
      rowData,
      rowDataPopup,
      groupPopup,
      group,
      isOpenMAI,
      isOpen,
      isLoading,
    } = this.state;

    const { translate } = this.props;

    const getModalContent = () => {
      if (isLoading) {
        return (
          <div className="setting_popup_wrap">
            <div className="setting_popup applying_policy">
              <Loader />
            </div>
          </div>
        );
      }
      return (
        <div className="setting_popup_wrap">
          <div className="setting_popup applying_policy">
            <div className="popup_scroll">
              <div className="setting_popup_header">
                <h2 className="popup_name">
                  {translate('modal.title.assigning_issue')}
                  <Popup
                    trigger={(
                      <em style={{ cursor: 'pointer' }}>
                        {rowData.length}
                        {translate('modal.title.selected')}
                      </em>
                    )}
                    on="click"
                    hideOnScroll
                    position="bottom left"
                    open={rowDataPopup}
                    onOpen={this.rowDataPopupOpen}
                    onClose={this.rowDataPopupClose}
                  >
                    <List>
                      {rowData.map((list) => {
                        if (Array.isArray(list)) {
                          return list.map((entity) => {
                            return (
                              <List.List key={uuidv4()} style={{ fontWeight: 'normal', fontSize: '12px' }}>{entity.name}</List.List>
                            );
                          });
                        }
                        return <List.List key={uuidv4()} style={{ fontWeight: 'normal', fontSize: '12px' }}>{list.name}</List.List>;
                      })}
                    </List>
                  </Popup>
                </h2>
                <a
                  className="popup_close_button"
                  onClick={this.closeModal}
                  onKeyUp={this.closeModal}
                  style={{ cursor: 'pointer' }}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <div className="setting_popup_contnets">
                <div className="setting_popup_content_wrap">
                  <div className="setting_popup_content">
                    <div className="search_box">
                      <span className="search_icon">
                        <img src={searchIcon} alt="" />
                      </span>
                      <input
                        type="text"
                        value={searchKeyword}
                        placeholder={this.guideText()}
                        onChange={this.handleProjectMemberChange}
                        onKeyPress={this.handleSearchMember}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                      />
                      <a
                        className="reset_icon"
                        onClick={this.clearSearch}
                        onKeyUp={this.clearSearch}
                      >
                        x
                      </a>
                      {errSearch && (
                        <Label basic color="red" pointing>
                          {translate('contents_header.message.least_two_required_to_search')}
                        </Label>
                      )}
                      {isFocus && <Label pointing>{translate('modal.title.label_name_email')}</Label>}
                    </div>
                  </div>
                  <div className="setting_popup_content">
                    <div className="table_wrap" style={{ height: '415px' }}>
                      <Scrollbars>
                        <Table
                          selectable
                          celled
                        >
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell>{translate('modal.title.user_name')}</Table.HeaderCell>
                              <Table.HeaderCell>{translate('modal.title.email')}</Table.HeaderCell>
                              <Table.HeaderCell>{translate('modal.title.assigned_group')}</Table.HeaderCell>
                              <Table.HeaderCell>{translate('modal.title.ongoing_issues')}</Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>
                            {
                              memberList.length !== 0
                                ? (
                                  memberList.map((item) => {
                                    return (
                                      <Table.Row
                                        key={uuidv4()}
                                        className={cx('assign_issue', {
                                          selected: selectedId === item.id,
                                        })}
                                        onClick={() => {
                                          this.handleSelectMember(item.id);
                                        }}
                                      >
                                        <Table.Cell>
                                          <Header as="h4" image>
                                            <Image src={this.getProfileImg(item.id)} rounded size="mini" />
                                            <Header.Content
                                              style={{ fontSize: '14px', color: '#474747' }}
                                            >
                                              {item.profile}
                                            </Header.Content>
                                          </Header>
                                        </Table.Cell>
                                        <Table.Cell>{this.convertToString(item.email)}</Table.Cell>
                                        <Table.Cell>
                                          {
                                            item.groups.length !== 0 ? (
                                              <Popup
                                                trigger={
                                                  <span style={{ cursor: 'pointer' }}>{item.groups.length}</span>
                                                }
                                                on="click"
                                                hideOnScroll
                                                position="bottom left"
                                                open={groupPopup && activeIndex === item.id}
                                                onOpen={() => {
                                                  return this.renderGroup(item.id, item.groups);
                                                }}
                                                onClose={this.renderCloseGroup}
                                              >
                                                <List>
                                                  {group.map((list) => {
                                                    return (
                                                      <List.Item key={uuidv4()}>
                                                        <List.Icon name="group" />
                                                        <List.Content>{list}</List.Content>
                                                      </List.Item>
                                                    );
                                                  })}
                                                </List>
                                              </Popup>
                                            ) : (
                                              <span>{item.groups.length}</span>
                                            )
                                          }
                                        </Table.Cell>
                                        <Table.Cell>{item.issues}</Table.Cell>
                                      </Table.Row>
                                    );
                                  })
                                ) : null
                            }
                          </Table.Body>
                        </Table>
                      </Scrollbars>
                    </div>
                  </div>
                </div>
                <div className="setting_popup_button_wrap">
                  <a
                    className="button cencel_button"
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                    style={{ cursor: 'pointer' }}
                  >
                    {translate('modal.button.cancel')}
                  </a>
                  <a
                    className="button save_button"
                    onClick={this.onSubmit}
                    onKeyUp={this.onSubmit}
                  >
                    {translate('modal.button.save')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };

    return (
      <Modal open={isOpenMAI} onClose={this.closeModal}>
        {getModalContent()}
        <Modal open={isOpen} onClose={this.closeErrorModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{translate('modal.title.attention')}</h2>
                <p className="text">{translate('modal.message.select_one_user')}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeErrorModal}
                    onKeyUp={this.closeErrorModal}
                    style={{ cursor: 'pointer' }}
                  >
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(AssigningIssueModal)));
